import { getInstance } from '@/modules/globals/utils/host'

const isProd = PROJECT_CONFIG.mode === 'prod'

let _resolve = null

let _Promise = new Promise(resolve => {
    _resolve = resolve
})

/**
 * 检查hostInstance是否已经初始化完成
 */
export const checkHostInstanceIsReady = () => {
    return _Promise
}

/**
 * 初始化全局变量hostInstance，、需要阻塞应用渲染
 */
export const initHostInstance = () => {
    return getInstance({ isProd }).then(instance => {
        window.hostInstance = instance
        _resolve()
    })
}
